/* eslint-disable max-lines */
import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { useTranslate } from '@im/react-localization';
import { getDate } from './internalETA/commonETAType';
import Typography from '@mui/material/Typography';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import WarehouseETAQuantityAvailablity from './internalETA/warehouseETAQuantityAvailablity';
import Alert from '@mui/material/Alert';

type PropTypes = {
  fromPage: string;
  reservedStock: number;
  siteCode: string;
  skuType?: string;
  stockStatus?: string;
  warehouseStockDetailUpdate: any;
};

const WarehouseETAGridData = (props: PropTypes) => {
  const translate = useTranslate();
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  const list = props.warehouseStockDetailUpdate as [];

  const onDemandStatus = props.warehouseStockDetailUpdate.find(
    (sta: any) => sta.onDemandFlag === true
  );

  function getNum(val: any) {
    if (isNaN(val)) {
      return 0;
    }
    return val;
  }

  function heightReturn(len: number) {
    if (len <= 2) return '140px';
    else if (len === 3) return '200px';
    else if (len === 4) return '240px';
    else if (len === 5) return '290px';
    else if (len === 6) return '340px';
    else if (len === 7) return '400px';
    else if (len === 8) return '420px';
    else if (len === 9) return '430px';
    else if (len === 10) return '450px';
    else if (len === 11) return '470px';
    else if (len === 12) return '490px';
    else if (len === 13) return '500px';
    else if (len === 14) return '510px';
    else if (len === 15) return '520px';
    else if (len > 16) return '530px';
  }
  return (
    <>
      <WarehouseDetailsBody container>
        <Grid
          container
          data-testid={'WarehouseETAGridData'}
          sx={{ alignContent: 'flex-start', display: 'flex', flex: 1 }}
        >
          <WarehouseTableHeader container>
            <Grid item xs={3}>
              {translate('Warehouse.ETAGridColumnStatus')}
            </Grid>
            <Grid item xs={3}>
              {translate('Warehouse.ETAGridColumnQuantity')}
            </Grid>
            <Grid item xs={3}>
              {translate('Warehouse.ETAGridColumnETS')}
              {'  '}
              <Tooltip
                arrow
                placement={'bottom-start'}
                title={translate('Warehouse.ETAExactShipTooltipsText')}
              >
                <InfoOutlinedIcon
                  sx={{ fontSize: '1.5rem', marginLeft: '8px' }}
                ></InfoOutlinedIcon>
              </Tooltip>
            </Grid>
          </WarehouseTableHeader>
          <Box
            sx={{
              height: isReadMore ? heightReturn(5) : heightReturn(list.length),
              overflowY: 'auto',
              width: '100%',
            }}
          >
            <Grid container sx={{ paddingLeft: '0rem' }}>
              {props.warehouseStockDetailUpdate !== undefined ? (
                props.warehouseStockDetailUpdate?.map(
                  (inStock: any, i: number) => (
                    <>
                      {!isReadMore ? (
                        <Grid
                          container
                          key={i}
                          sx={{
                            borderBottom: 1,
                            borderBottomColor: '#C4C4C4',
                            p: 1.5,
                          }}
                        >
                          <Grid item pl={1} xs={3}>
                            {inStock.stockStatusDisplayFlag
                              ? inStock.stockStatus
                              : ''}
                          </Grid>
                          <Grid item xs={3}>
                            <WarehouseETAQuantityAvailablity
                              centralFlag={inStock.centralFlag}
                              quantity={getNum(inStock.quantity)}
                              stockStatus={inStock.stockStatus}
                            ></WarehouseETAQuantityAvailablity>
                          </Grid>
                          <Grid item xs={6}>
                            {inStock.stockStatues === 'INSTOCK'
                              ? inStock.eTShipmenttext
                              : [
                                  inStock.eta !== undefined &&
                                  inStock.eta !== '-'
                                    ? [
                                        inStock.eta?.toLowerCase() ===
                                        'not available'
                                          ? translate(
                                              'Warehouse.ETAnotavailable'
                                            )
                                          : getDate(inStock.eta),
                                      ]
                                    : '-',
                                ]}
                            {inStock.stockStatues === 'INSTOCK' &&
                            getNum(props.reservedStock) > 0 &&
                            props.reservedStock === getNum(inStock.quantity) ? (
                              <Typography
                                component="span"
                                sx={{
                                  color: '#054F31',
                                  fontWeight: '600',
                                }}
                              >
                                {' '}
                                {translate('Warehouse.ETAGridOnReservedText')}
                              </Typography>
                            ) : null}
                            {inStock.stockStatues === 'ONORDER' &&
                            getNum(inStock.reservedQuantity) > 0 ? (
                              <Typography
                                component="span"
                                sx={{
                                  color: '#067647',
                                  fontSize: '14px',
                                  fontWeight: '400',
                                }}
                              >
                                {' '}
                                {translate('Warehouse.ETAGridOnReservedText')}
                              </Typography>
                            ) : null}
                          </Grid>
                        </Grid>
                      ) : (
                        i <= 4 && (
                          <Grid
                            container
                            key={i}
                            sx={{
                              borderBottom: 1,
                              borderBottomColor: '#C4C4C4',
                              p: 1.5,
                            }}
                          >
                            <Grid item pl={1} xs={3}>
                              {inStock.stockStatusDisplayFlag
                                ? inStock.stockStatus
                                : ''}
                            </Grid>
                            <Grid item xs={3}>
                              <WarehouseETAQuantityAvailablity
                                centralFlag={inStock.centralFlag}
                                quantity={inStock.quantity}
                                stockStatus={inStock.stockStatus}
                              ></WarehouseETAQuantityAvailablity>
                            </Grid>
                            <Grid item xs={6}>
                              {inStock.stockStatues === 'INSTOCK'
                                ? inStock.eTShipmenttext
                                : [
                                    inStock.eta !== undefined &&
                                    inStock.eta !== '-'
                                      ? [
                                          inStock.eta?.toLowerCase() ===
                                          'not available'
                                            ? translate(
                                                'Warehouse.ETAnotavailable'
                                              )
                                            : getDate(inStock.eta),
                                        ]
                                      : '-',
                                  ]}
                              {getNum(inStock.reservedQuantity) > 0 &&
                              inStock.stockStatues === 'ONORDER' ? (
                                <Typography
                                  component="span"
                                  sx={{
                                    color: '#067647',
                                    fontSize: '14px',
                                    fontWeight: '400',
                                  }}
                                >
                                  {' '}
                                  {translate('Warehouse.ETAGridOnReservedText')}
                                </Typography>
                              ) : null}
                              {inStock.stockStatues === 'INSTOCK' &&
                              getNum(props.reservedStock) > 0 &&
                              getNum(props.reservedStock) ===
                                inStock.quantity ? (
                                <Typography
                                  component="span"
                                  sx={{
                                    color: '#054F31',
                                    fontWeight: '600',
                                  }}
                                >
                                  {' '}
                                  {translate('Warehouse.ETAGridOnReservedText')}
                                </Typography>
                              ) : null}
                            </Grid>
                          </Grid>
                        )
                      )}
                    </>
                  )
                )
              ) : (
                <>
                  <Grid
                    container
                    key={0}
                    sx={{
                      borderBottom: 1,
                      borderBottomColor: '#C4C4C4',
                      p: 1.5,
                    }}
                  >
                    <Grid item pl={1} xs={3}>
                      {'-'}
                    </Grid>
                    <Grid item xs={3}>
                      {'-'}
                    </Grid>
                    <Grid item xs={6}>
                      {'-'}
                    </Grid>
                  </Grid>
                </>
              )}
            </Grid>
            {list !== undefined && list?.length > 5 && (
              <Box
                component="span"
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  textAlign: 'center',
                }}
              >
                <Typography
                  component="span"
                  onClick={toggleReadMore}
                  sx={{
                    alignContent: 'center',
                    alignItems: 'center',
                    color: '#0164B0',
                    fontSize: '14px',
                    fontWeight: '400',
                    lineHeight: '50px',
                    margin: 'auto',
                    textAlign: 'center',
                  }}
                  variant="body2"
                >
                  {isReadMore ? (
                    <>
                      <Typography
                        component="span"
                        sx={{ cursor: 'pointer', textDecoration: 'underLine' }}
                      >
                        {translate('Warehouse.ETAGridShowMoreText')} (
                        {list.length > 5 ? list.length - 5 : list.length})
                      </Typography>
                      <ExpandMoreRoundedIcon
                        sx={{ fontSize: '1.3rem', marginLeft: '5px' }}
                      ></ExpandMoreRoundedIcon>
                    </>
                  ) : (
                    <>
                      <Typography
                        component="span"
                        sx={{ cursor: 'pointer', textDecoration: 'underLine' }}
                      >
                        {translate('Warehouse.ETAGridShowLessText')}
                      </Typography>
                      <ExpandLessRoundedIcon
                        sx={{ fontSize: '1.3rem', marginLeft: '5px' }}
                      ></ExpandLessRoundedIcon>
                    </>
                  )}
                </Typography>
              </Box>
            )}
            {props.stockStatus?.toUpperCase() === 'OUTOFSTOCK' &&
              onDemandStatus && (
                <>
                  <br />
                  <Alert severity="warning" sx={{ height: '45px' }}>
                    {translate('Warehouse.ETAGridStatusOnDemand')}
                  </Alert>
                </>
              )}
          </Box>
        </Grid>
      </WarehouseDetailsBody>
    </>
  );
};

export default WarehouseETAGridData;

const WarehouseTableHeader = styled(Grid)(({ theme }) => ({
  '& .MuiGrid-item': { alignItems: 'flex-end', display: 'flex' },
  backgroundColor: '#F8F8F8',
  borderBottom: 'solid 2px #0077D4',
  display: 'flex',
  flexWrap: 'nowrap',
  fontSize: '14px',
  fontWeight: 'bold',
  padding: theme.spacing(3, 1.5, 0.5),
}));

const WarehouseDetailsBody = styled(Grid)(() => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  justifyContent: 'space-between',
  typography: 'body1',
  width: '100%',
}));
